export const messages = {
  configurePageTitle: 'Configure Club / Punchcard',
  updatePageTitle: 'Update Club / Punchcard',
  subtitle: 'Build member habits through repeat product purchases',
};
